import React from 'react';
import './siteTexture.css';

// The ground under every public page: the login screen's texture, page-wide
// (AuthShell.js — dot grid, hexagon outlines, drifting glows, circuit traces
// with a dash of light running along each one, breathing node pads).
// Everything moves in place; nothing travels across the copy or off the
// page — the login's scanline is left out on purpose: across a full page its
// 160px band read as a hard bright block behind the headline. A radial mask
// thins the pattern under the reading column so the copy sits on calm ground
// and the texture lives at the edges.
//
// One trace is gold: the admitted write, the one signal the site draws in
// gold everywhere else. The rest are teal.
//
// Decorative: hidden from AT, flows and pings frozen under reduced motion,
// traces off on phones, the whole layer off while Explore has the 3D world
// up (`body.pw-explore`).

// Orthogonal routes on a 1600×900 sheet, anchored to the top. They thin out
// toward the middle of the sheet where the copy column sits.
const ROUTES = [
  'M-20 140 H260 V300 H520 V220 H900',
  'M120 -20 V110 H420 V60 H760 V190 H1040',
  'M-20 520 H200 V420 H480 V600 H820 V480 H1100',
  'M300 760 V640 H620 V820 H960 V700 H1260',
  'M700 -20 V130 H880 V360 H1120',
  'M1620 240 H1340 V400 H1080 V560 H1380 V700 H1620',
  'M1480 -20 V160 H1240 V40 H1000',
  'M1620 820 H1300 V880',
  'M-20 860 H160 V740',
  'M560 920 V860 H840 V760',
];
const GOLD = 5; // the route that carries the gold dash

const NODES = [
  [260, 140], [520, 300], [420, 110], [760, 60], [1040, 190], [200, 520], [480, 420],
  [820, 600], [620, 640], [960, 820], [880, 130], [1120, 360], [1340, 240], [1080, 400],
  [1380, 560], [1240, 160], [1300, 820], [160, 860], [840, 860],
];

function Traces() {
  return (
    <svg className="st-traces" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMin slice" aria-hidden="true">
      {ROUTES.map((d) => <path key={d} d={d} className="st-trace-base" />)}
      {ROUTES.map((d, i) => (
        <path key={`f${d}`} d={d} className={`st-trace${i === GOLD ? ' is-gold' : ''}`} style={{ '--st-delay': `${i * -1.9}s` }} />
      ))}
      {NODES.map(([x, y], i) => (
        <g key={`${x}-${y}`} className="st-node" style={{ '--st-delay': `${i * -0.7}s` }}>
          <circle cx={x} cy={y} r="2.5" />
          <circle cx={x} cy={y} r="7" className="st-node-ring" />
        </g>
      ))}
    </svg>
  );
}

export default function SiteTexture() {
  return (
    <div className="st" aria-hidden="true">
      <div className="st-grid" />
      <span className="st-glow st-glow-a" />
      <span className="st-glow st-glow-b" />
      <span className="st-glow st-glow-c" />
      <Traces />
    </div>
  );
}
